import { createContext, ReactNode, useCallback, useContext, useRef } from 'react';

interface AddVideosModalContextType {
  closeAddVideosModal: () => void;
  registerClose: (fn: () => void) => () => void;
}

const AddVideosModalContext = createContext<AddVideosModalContextType | null>(null);

export const useAddVideosModal = () => useContext(AddVideosModalContext);

interface AddVideosModalProviderProps {
  children: ReactNode;
}

export const AddVideosModalProvider = ({ children }: AddVideosModalProviderProps) => {
  const closeFnsRef = useRef<Set<() => void>>(new Set());

  const registerClose = useCallback((fn: () => void) => {
    closeFnsRef.current.add(fn);
    return () => {
      closeFnsRef.current.delete(fn);
    };
  }, []);

  const closeAddVideosModal = useCallback(() => {
    closeFnsRef.current.forEach((fn) => fn());
  }, []);

  const value: AddVideosModalContextType = { closeAddVideosModal, registerClose };

  return <AddVideosModalContext.Provider value={value}>{children}</AddVideosModalContext.Provider>;
};
